import { DEFAULT_NAME, X_CSRF_TOKEN, languagesMapping } from './constants';
import * as custom from './custom';

const proxyTarget = process.env.proxyTarget ?? '';

const projectCode = 'product';

const documentTitle = `${process?.env?.project || ''} ${DEFAULT_NAME}`;

const publicPath = '/bcsc-service';

const antd = {
  configProvider: {
    componentSize: 'middle',
  },
  theme: {
    components: {
      Tabs: {
        horizontalItemPadding: '12px 12px',
        itemSelectedColor: '#FF5E00',
        inkBarColor: '#FF5E00',
        itemHoverColor: '#FF5E00',
      },
      Menu: {
        horizontalItemHoverColor: '#FF5E00',
        horizontalItemSelectedColor: '#FF5E00',
      },
      Empty: {
        colorText: 'rgba(0, 0, 0, 0.25)',
      },
    },
    token: {
      colorPrimary: '#1800E7',
      fontFamily: 'Roboto',
      colorLink: '#FF5E00',
    },
  },
};

export default {
  antd,
  proxyTarget,
  projectCode,
  X_CSRF_TOKEN,
  documentTitle,
  languagesMapping,
  publicPath,
  ...custom,
};
